import { fromJS } from 'immutable'
import { savePreviewData } from 'functions/previewHandler'

const initialState = fromJS({
  owner: '',
  name: '',
  logo: '',
  header: 'A',
  bottomBar: {
    showText: true,
    iconSize: 30
  },
  drawer: {
    iconSize: 30,
    textSize: 20
  },
  logofile: '',
  logoLogin: '',
  logoLoginFile: '',
  headerlogo: '',
  headerlogofile: '',
  iosLogos: {
    ico192: '',
    ico192Life: '',
  },
  created: '',
  timeZone: '',
  appid: '',
  id: '',
  colors: {
    primary: '#ABB8C3',
    secondary: '#000000',
  },
  auth: {
    allowNoLogIn: true,
    allowSignIn: false,
    email: false,
    facebook: false,
    google: false,
    showAppName: false,
    twitter: false
  },
  plan: '',
  changes: false,
  showSteps: true,
  messaging: false,
  percent: -100
})

const appgeneral = (state = initialState, action) => {
  switch (action.type) {
    case "CLEAR_APP_CONFIG":
      return state.merge({
        owner: '',
        name: '',
        appid: '',
        id: '',
        logo: '',
        header: 'A',
        bottomBar: {
          showText: true,
          iconSize: 30
        },
        drawer: {
          iconSize: 30,
          textSize: 20
        },
        logofile: '',
        logoLogin: '',
        logoLoginFile: '',
        headerlogo: '',
        headerlogofile: '',
        iosLogos: {
          ico192: '',
          ico192Life: '',
        },
        created: '',
        timeZone: '',
        colors: {
          primary: '#ABB8C3',
          secondary: '#000000',
        },
        auth: {
          allowNoLogIn: true,
          allowSignIn: false,
          email: false,
          facebook: false,
          google: false,
          showAppName: false,
          twitter: false
        },
        plan: '',
        changes: false,
        showSteps: true,
        shortId: '',
        ownerid: '',
        previewId: '',
        messaging: false,
        percent: -100
      })
    case "SET_APP_NAME":
      return state.merge({
        name: action.payload.name,
      })
    case "SET_APP_CONFIG":
      savePreviewData(state.get('appid'), action.payload)
      return state.merge({
        ...action.payload
      })
    case "CHANGE_APP_CONFIG":
      return state.merge({
        ...action.payload
      })
    default:
      return state
  }
}

export default appgeneral